document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('.anchor-links__sticky button[data-section]');
  window.addEventListener('scroll', () => {
    const fromTop = window.scrollY;
    const announcementContainerHeight = document?.querySelector(".announcement-bar")?.clientHeight || 0
    const headerContainerHeight = document.querySelector(".section-header")?.clientHeight || 0;
    const headerOffset = headerContainerHeight + announcementContainerHeight + document.querySelector('.anchor-links__sticky').clientHeight;
    links.forEach(link => {
      const sectionElements = document.querySelectorAll(`[data-anchor="${link.dataset.section}"]`);
      let isActive = false;
      sectionElements.forEach(sec => {
        const closestSection = sec.closest(".shopify-section");
        if (closestSection) {
          const top = closestSection.offsetTop - headerOffset;
          const bottom = closestSection.offsetTop + closestSection.clientHeight - headerOffset;
          if (fromTop >= top && fromTop < bottom) {
            isActive = true;
            const htab_container = document.querySelector('.anchor-links__list');
            const htab_tabRect = link.getBoundingClientRect();
            const htab_containerRect = htab_container.getBoundingClientRect();
            const scrollLeft = htab_container.scrollLeft + (htab_tabRect.left - htab_containerRect.left) - (htab_containerRect.width / 2 - htab_tabRect.width / 2);
            htab_container.scrollTo({
              left: scrollLeft
            });             
          }
        }
      });
      if (isActive) { link.classList.add('active'); }else { link.classList.remove('active'); }
    });
  });
  
  if ( document.querySelectorAll('.page__fd__media_swiper.swiper').length > 0 ){
    document.querySelectorAll('.page__fd__media_swiper.swiper').forEach((swiperinitilize) => {
      new Swiper(swiperinitilize, {
        pagination: { el: ".swiper-pagination", clickable: true },
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev"}         
      });
    }); 
  }

  if ( document.querySelectorAll('.table__featured__swiper.swiper').length > 0 ){
    document.querySelectorAll('.table__featured__swiper.swiper').forEach((swiperinitilize) => {
      new Swiper(swiperinitilize, {
        slidesPerView: 'auto',
        pagination: { el: ".swiper-pagination.pagination_table_chart", clickable: true },
        navigation: { nextEl: ".swiper-button-next.next_table_chart", prevEl: ".swiper-button-prev.prev_table_chart" }         
      });
    }); 
  }

  if( document.querySelectorAll('a.image-content__button').length > 0 ){
    document.querySelectorAll('a.image-content__button').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        let lastSlashIndex = event.currentTarget.href.lastIndexOf('/');
        if (lastSlashIndex !== -1) {
            let pathAnchor = event.currentTarget.href.substring(lastSlashIndex + 1);
            const targetElement = document.querySelector(`[data-anchor="${pathAnchor}"]`);
            const sectionHeader = document.querySelector('.section-header');
            if (!targetElement || !sectionHeader) return;
            const totalTop = sectionHeader.clientHeight + document?.querySelector('[data-section-type="page-anchor-links"]')?.clientHeight;
            window.scrollTo({
              top: targetElement.offsetTop - totalTop,
              behavior: 'smooth'
            });
        }        
      });
    });
  }

  if( document.querySelectorAll('[js-scroll-target-anchor]').length > 0 ){
    document.querySelectorAll('[js-scroll-target-anchor]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        let lastSlashIndex = event.currentTarget.href.lastIndexOf('/');
        if (lastSlashIndex !== -1) {
            let pathAnchor = event.currentTarget.href.substring(lastSlashIndex + 1);
            const targetElement = document.querySelector(`[data-anchor="${pathAnchor}"]`);
            const sectionHeader = document.querySelector('.section-header');
            if (!targetElement || !sectionHeader) return;
            const totalTop = sectionHeader.clientHeight + document?.querySelector('[data-section-type="page-anchor-links"]')?.clientHeight;
            window.scrollTo({
              top: targetElement.offsetTop - totalTop,
              behavior: 'smooth'
            });
        }        
      });
    });
  }  
  
  class CustomSelectionVariant extends HTMLElement{
    constructor(){
      super();
      this.querySelectorAll('input[type="radio"]').forEach((elm)=>{
        elm.addEventListener('change', ()=>{
          this.updateRadioOption();
        })
      })
    }
    updateRadioOption(){
      this.updateOptions();
      this.updateMasterId();
      this.updatequickadd();
    }
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('input[type="radio"]:checked'), (input) => input.value);
    }   
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }   
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    // edited by Skio
    getProductData() {
      return this.productData ||= JSON.parse(this.querySelector('[data-product]').textContent);
    }  
    updatequickadd(){
      if(this.currentVariant){
        this.closest('.page_fd__image_content').querySelector('[name="id"]').value = this.currentVariant.id;
        
        // Filter to only use selling plans from app_id 5859381
        // edited by Skio
        const productData = this.getProductData();
        const filteredSellingPlanGroups = productData.selling_plan_groups.filter(selling_plan_group => 
          selling_plan_group.app_id === 'SKIO'
        );
        
        // Get valid selling plan IDs from filtered groups
        const validPlanIds = new Set();
        filteredSellingPlanGroups.forEach(group => {
          if (group.selling_plans) {
            group.selling_plans.forEach(plan => validPlanIds.add(plan.id));
          }
        });
        
        // Find first matching allocation
        const validAllocation = this.currentVariant.selling_plan_allocations.find(allocation =>
          validPlanIds.has(allocation.selling_plan_id)
        );
        
        if (validAllocation) {
          this.closest('.page_fd__image_content').querySelector('[name="selling_plan_id"]').value = validAllocation.selling_plan_id;
          this.closest('.page_fd__image_content').querySelector('[name="selling_plan"]').value = validAllocation.selling_plan_id;
        } else {
          console.warn('No selling plan allocations found for app_id SKIO');
          this.closest('.page_fd__image_content').querySelector('[name="selling_plan_id"]').value = this.currentVariant.selling_plan_allocations[0].selling_plan_id; // fallback
          this.closest('.page_fd__image_content').querySelector('[name="selling_plan"]').value = this.currentVariant.selling_plan_allocations[0].selling_plan_id; // fallback
        }
        // edited by Skio
        if( this.currentVariant.available && (this.currentVariant.compare_at_price > this.currentVariant.price) ){
          this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).disabled = false;
          this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).innerHTML = `Add to Cart —&nbsp;$${(this.currentVariant.selling_plan_allocations[0].price / 100).toFixed(2)} <s>${(this.currentVariant.compare_at_price / 100).toFixed(2)}</s>`;
        }else if(this.currentVariant.available){
          this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).disabled = false;
          this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).innerHTML = `Add to Cart —&nbsp;$${(this.currentVariant.selling_plan_allocations[0].price / 100).toFixed(2)} <s>${(this.currentVariant.price / 100).toFixed(2)}</s>`;          
        }else if( !this.currentVariant.available && (this.currentVariant.compare_at_price > this.currentVariant.price) ){
          this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).disabled = true;
          this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).innerHTML = `Sold Out —&nbsp;$${(this.currentVariant.selling_plan_allocations[0].price / 100).toFixed(2)} <s>${(this.currentVariant.compare_at_price / 100).toFixed(2)}</s>`;
        }else if(!this.currentVariant.available){
          this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).disabled = true;
          this.closest('.page_fd__image_content').querySelector(`.product-form__submit[type="submit"]`).innerHTML = `Sold Out —&nbsp;$${(this.currentVariant.selling_plan_allocations[0].price / 100).toFixed(2)} <s>${(this.currentVariant.price / 100).toFixed(2)}</s>`;          
        }      
      }
    }
  }
  customElements.define('cus-variant-radios',CustomSelectionVariant)

  const getGuid = ()=> {
      let d = new Date().getTime();
      let d2 =  (performance && performance.now && (performance.now() * 1000)) || 0;
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
          let r = Math.random() * 16;
          if (d > 0) {
              r = (d + r) % 16 | 0;
              d = Math.floor(d / 16);
          } else {
              r = (d2 + r) % 16 | 0;
              d2 = Math.floor(d2 / 16);
          }
          return (c == 'x' ? r: (r & 0x7 | 0x8)).toString(16);
      }); 
  }

  if( document.querySelectorAll('.js-mainproduct-submit').length > 0 ) {
    const mainProductIdMap = {};
    let mainProductBoxIndexCounter = 0;    
    document.querySelectorAll('.js-mainproduct-submit').forEach((elm) => {
      elm.addEventListener('click', (event) => {
        event.preventDefault();
        const Etarget = event.currentTarget;
        const productFormObject = Etarget.closest('.product__form_object');
        const submitButton = Etarget.closest('.product-form__buttons').querySelector('button');
        submitButton.classList.add('loading');
        submitButton.disabled = true;
        let cartElement = document.querySelector("cart-drawer");
        if (cartElement) cartElement.enableLoading();
        let itemsToAdd = [];
        const isCustomProcess = Etarget.closest('[data-cart-process="true"]');
        if (isCustomProcess) {
          const currentVariantId = productFormObject.querySelector('[name="id"]').value;
          const sectionContainer = Etarget.closest('[data-cart-process]');
          const bundleJson = JSON.parse(sectionContainer.querySelector('.bundle-data-json').textContent);
          const data = bundleJson[currentVariantId] || bundleJson["default"];
          if (data && data.ids) {
            let uniqID = new Date().getTime().toString(),
            bundleID = data.dynbox,
            customImage = data.custom_image,
            customProductTitle = data.product_title,
            customTitle = data.custom_title,
            customServing = data.custom_servings,
            customPrice = data.custom_price,
            customComparePrice = data.custom_compare_price,
            customSubPrice = data.custom_sub_price,
            customSubComparePrice = data.custom_sub_compare_price,                        
            customQuantity = data.custom_quantity,
            customQuantityGroup = data.qtys,
            customSellingPlan = data.custom_selling_plan,
            dynamicBoxIndex = 0;
            if (bundleID && bundleID.toString().trim() !== '') {
                const trimmedBundleID = bundleID.toString().trim();
                if (mainProductIdMap[trimmedBundleID] === undefined) {
                    mainProductIdMap[trimmedBundleID] = mainProductBoxIndexCounter;
                    mainProductBoxIndexCounter++;
                }
                dynamicBoxIndex = mainProductIdMap[trimmedBundleID];
            }
            const mainProperties = {
                _dynamicBoxId: bundleID,
                _dynamicBoxIndex: dynamicBoxIndex,
                _custom_image:customImage,
                _custom_product_title:customProductTitle,
                _custom_title:customTitle,
                _custom_serving:customServing,
                _custom_price:customPrice,
                _custom_compare_price:customComparePrice,
                _custom_sub_price:customSubPrice,
                _custom_sub_compare_price:customSubComparePrice,                            
                _custom_quantity:customQuantity,
                _custom_quantity_group:customQuantityGroup,
                _customSellingPlanName:customSellingPlan
            };   
            const idArray = typeof data.ids === 'string' ? data.ids.split(',') : data.ids;
            const planArray = typeof data.plans === 'string' ? data.plans.split(',') : (data.plans || []);
            const qtyArray = typeof data.qtys === 'string' ? data.qtys.split(',') : (data.qtys || []);
            itemsToAdd = idArray.map((id, index) => {
                const itemBaseQty = parseInt(qtyArray[index]) || 1;
                const itemProperties = { 
                  ...mainProperties,
                  _base_qty: itemBaseQty.toString(),
                  _role: index === 0 ? 'main' : 'hidden',
                  _uniqBundleId: uniqID,
                  _selling_plan_id: parseInt(planArray[index])
                };
                const item = {
                    id: id.toString().trim(),
                    quantity: itemBaseQty,
                    properties: itemProperties
                };
                if (planArray[index] && planArray[index] !== "") {
                    item.selling_plan = parseInt(planArray[index]);
                }
                return item;
            });
          }
        } else {
          let sellingId = productFormObject.querySelector('[name="selling_plan"]')?.value;
          let targetId = productFormObject.querySelector('[name="id"]').value;
          itemsToAdd.push({
            id: targetId,
            quantity: 1,
            selling_plan: sellingId || null
          });
        }
        const productShouldBe = {
          items: itemsToAdd,
          sections: cartElement ? cartElement.getSectionsToRender().map((section) => section.section) : [],
          sections_url: window.location.pathname
        };
        console.log(productShouldBe);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(productShouldBe),
          credentials: 'same-origin'
        })
        .then(async (response) => {
            const data = await response.json();
            if (!response.ok) {
                console.error("Shopify Cart Error Response:", data);
                throw new Error(data.description || data.message || "Failed to add items to cart (409 Conflict)");
            }
            return data;
        })
        .then((parsedState) => {
          if (cartElement) cartElement.renderContent(parsedState.sections);
        })
        .catch((e) => console.error(e))
        .finally(() => {
          if (cartElement) {
            cartElement.disableLoading();
            cartElement.open();
          }
          submitButton.classList.remove('loading');
          submitButton.disabled = false;
        });
      });
    });
  }

  const REVIEW_API_BASE = 'https://api.okendo.io/v1';
  const STORE_ID = 'ddccf316-2614-49f7-8641-7b411da6bacb';
  const COLLECTION_ID = 'c95c5011-c412-4f6c-bc87-cdb7a8e9b16e';
  const INITIAL_API_URL = `${REVIEW_API_BASE}/stores/${STORE_ID}/collections/${COLLECTION_ID}/reviews`;
  const loadMoreReviewsBtn = document.getElementById('load-more-reviews');
  const reviewContainer = document.getElementById('chronic-review-container');
  let nextUrl = null;
  
  function toggleLoadMore(url) {
    if (!loadMoreReviewsBtn) return;
    loadMoreReviewsBtn.classList.toggle('hidden', !url);
  }
  
  function createReviewItem(item) {
    const gridItem = document.createElement('div');
    gridItem.className = 'review-grid-item';
    const avatarUrl = item?.reviewer?.avatarUrl || item?.productImageUrl || '';
    const avatarAlt = item?.reviewer?.displayName || item?.productName || 'avatar';
    const avatar = `<img style="width: 72px; height: 72px; object-fit: cover; border-radius: 5px;" alt="${avatarAlt}" src="${avatarUrl}"> `;
    const ratingPercent = `${(item?.rating || 0) * 20}%`;
    gridItem.innerHTML = `
      <span class="okeReviews-starRating-indicator" role="presentation rating-${item?.rating}">
        <span class="okeReviews-starRating-indicator-layer"></span>
        <span class="okeReviews-starRating-indicator-layer okeReviews-starRating-indicator-layer--foreground" style="width: ${ratingPercent}"></span>
      </span>
      <h3>${item?.title || ''}</h3>
      <p>${item?.body || ''}</p>
      <p style="display: flex; align-items: center; gap: 16px;">${avatar}<span>${item?.reviewer?.displayName || ''}</span></p>
    `;
    return gridItem;
  }
  
  function loadReviews(data, setPosition = false) {
    const reviews = data?.reviews;
    if (!reviews?.length || !reviewContainer) return;
    const fragment = document.createDocumentFragment();
    reviews.forEach(item => {
      const reviewEl = createReviewItem(item);
      fragment.appendChild(reviewEl);
    });
    reviewContainer.appendChild(fragment);
    if (setPosition) {
      const promoBanner = reviewContainer.querySelector('.promo__banner');
      const thirdReview = reviewContainer.querySelectorAll('.review-grid-item')[2];
      if (promoBanner && thirdReview) {
        reviewContainer.insertBefore(promoBanner, thirdReview);
      }
    }
    nextUrl = data?.nextUrl ? `${REVIEW_API_BASE}${data.nextUrl}` : null;
    toggleLoadMore(nextUrl);
  }
  
  async function fetchReviews(url = INITIAL_API_URL) {
    try {
      const response = await fetch(url);
      return await response.json();
    } catch (error) {
      console.error('Error fetching reviews:', error);
      return null;
    }
  }
  
  (async () => {
    const data = await fetchReviews();
    if (data) {
      loadReviews(data, true);
    }
  })();
  
  if (loadMoreReviewsBtn) {
    loadMoreReviewsBtn.addEventListener('click', async () => {
      if (!nextUrl) return;
      loadMoreReviewsBtn.disabled = true;
      const moreData = await fetchReviews(nextUrl);
      if (moreData) {
        loadReviews(moreData);
      }
      loadMoreReviewsBtn.disabled = false;
    });
  }

  const progressbars = document.querySelectorAll(".clicial_results_progressbar");
  if(progressbars){
    function isInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + 30
      );
    }
    function animateDigits(element, target) {
      const duration = 1500;
      const startTime = performance.now();
      function update(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        element.textContent = Math.ceil(progress * target);
        if (progress < 1) {
          requestAnimationFrame(update);
        }
      }
      requestAnimationFrame(update);
    }
    function animateCircleProgress(canvas, percent) {
      const context = canvas.getContext("2d");
      const radius = canvas.width / 2 - 5;
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const thickness = 5;
      const duration = 1500;
      const start = -Math.PI / 2;
      const end = percent * 2 * Math.PI + start;
      let startTime = null;
      function draw(currentTime) {
        if (!startTime) startTime = currentTime;
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const currentEnd = start + progress * (end - start);
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.beginPath();
        context.lineWidth = thickness;
        context.strokeStyle = "#DEF647";
        context.arc(centerX, centerY, radius, start, currentEnd, false);
        context.stroke();
        if (progress < 1) {
          requestAnimationFrame(draw);
        }
      }
      requestAnimationFrame(draw);
    }
    function animateElements() {
      progressbars.forEach(function (bar) {
        if (!bar.getAttribute("data-animate") && isInViewport(bar)) {
          bar.setAttribute("data-animate", "true");
          const circleWrapper = bar.querySelector(".clicial_results_circle");
          const percent = parseInt(circleWrapper.getAttribute("data-percent"), 10) || 0;
          const count = parseInt(circleWrapper.getAttribute("data-count"), 10) || 0;
          const digits = circleWrapper.querySelectorAll(".clicial_results_digitsLyt st");
          let canvas = circleWrapper.querySelector("canvas");
          if (!canvas) {
            canvas = document.createElement("canvas");
            canvas.width = 100;
            canvas.height = 100;
            circleWrapper.appendChild(canvas);
          }
          animateCircleProgress(canvas, percent / 100);
          digits.forEach(function (digit) {
            animateDigits(digit, count);
          });
        }
        if (!isInViewport(bar)) {
          bar.removeAttribute("data-animate");
        }
      });
    }
    animateElements();
    window.addEventListener("scroll", animateElements);  
  }
})